import { isObject, isFunction } from '../type';
import { getUrlParam } from '../url';
import platform, {
  getPlatformInfo,
  PlatformEnum,
} from '@tencent/wphk-platform-adapter';

const { platformType } = getPlatformInfo();

/**
 * 从 userAgent 中获取语言标识
 */
function getFromUserAgent(): string {
  const ms = platform.navigator.userAgent.match(/\s*Language\/([^\s]+)/);
  return ms && ms[1] ? ms[1] : '';
}

/**
 * 从navigator中获取
 * @returns {string}
 */
function getFromNavigator() {
  let lang = '';
  const { navigator } = platform;
  // ie10 没有 navigator.language, 有 userLanguage
  if (navigator) {
    const { language, userLanguage, browserLanguage, systemLanguage } =      navigator as any;
    lang = language || userLanguage || browserLanguage || systemLanguage || '';
  }
  return lang;
}

/**
 * 获取原始的语言标识
 * @returns 语言标识，如 zh-HK、en-US、zh-CN
 */
export function getOriginLang(): string {
  switch (platformType) {
    case PlatformEnum.LiteApp:
      return lite.system.getSystemInfo().language;

    case PlatformEnum.Miniprogram:
      return wx.getAppBaseInfo().language;

    default:
      return getFromUserAgent() || getFromNavigator();
  }
}

/**
 * 语言标识格式化参数
 * @example
 * {
 *   key: 'lang',
 *   keyMap: {
 *     'zh-tw': () => 'zh-hk',
 *     'zh-cn': () => 'zh-hk',
 *   },
 *   defaultLang: 'en',
 * }
 */
export type LangFormatOptions = {
  /** 页面URL上指定的语言标识参数key，如 ?lang=en，lang即为这里的key */
  key: string;
  /** 语言映射表，如果：{'zh-tw': () => 'zh-hk'} */
  keyMap: Record<string, () => string>;
  /** 默认语言，无法获取语言标识的情况下的默认兜底语言，一般为en */
  defaultLang: string;
};

/**
 * 从指定的范围中选择语言，如果没有，则返回默认语言
 * @param selectArr 指定的语言标识范围 如：['zh-hk', 'en-us']
 * @param options 语言标识格式化参数
 * @returns {string}
 */
export function getLang(selectArr: string[], options: LangFormatOptions) {
  const { key, keyMap, defaultLang } = options;
  const formatLang = (lang = '') => lang.replace(/_/g, '-').toLowerCase();
  let lang = getUrlParam(key) || getOriginLang() || '';
  lang = formatLang(lang);
  const formattedArr = selectArr.map(formatLang);
  if (isObject(keyMap) && isFunction(keyMap[lang])) {
    lang = keyMap[lang]?.() || ''; // 做映射
  }
  return formattedArr.indexOf(lang) > -1 ? lang : defaultLang;
}
